import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderCircuitService {

  private _refreshOrderCircuit = new Subject<void>();

  /**
   * Constructor
   *
   * @param {HttpClient} _httpClient
   */
  constructor(private _httpClient: HttpClient) { }

  get refreshOrderCircuit() {
    return this._refreshOrderCircuit;
  }

  getAll() {
    return this._httpClient.get(`${environment.apiUrl}/api/liste/orderCircuit`);
  }

  create(book, circuit, start, end) {
    return this._httpClient
      .post(`${environment.apiUrl}/api/create/orderCircuit`, { book, circuit, start, end })
      .pipe(
        tap(() => {
          this._refreshOrderCircuit.next()
        })
      );
  }
}
